import React from "react"
import StorePageV5 from "./cpq/StorePageV5"

const MuiStorePage = () => {
  return <StorePageV5 />
}

export default MuiStorePage
